
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { EnableSidebar } from '../../../../_metronic/layout/core'
import { KnowledgeWidget } from '../../../../_metronic/partials/widgets/feeds/KnowledgeWidget'
import { getAllVisibleKnowledgeByMenuID } from '../../auth/core/_api'
import { knowledgeModel } from '../../../../app/modules/auth';
import { useSearchParams } from 'react-router-dom';
import { MultiKnowledgeWidget } from './MultiKnowledge';

const MultipleKnowledge: FC = () => {
    const [searchParams] = useSearchParams()
    const [knowledges, setKnowledges] = useState<knowledgeModel[]>()
    const [mid, setMID] = useState<string | null>()
    const [mname, setMName] = useState<string | null>()

    useEffect(() => {
        async function updateKnowledge(mid: string | null) {
            const items = await getAllVisibleKnowledgeByMenuID(mid)
            var item_arr = new Array<knowledgeModel>()
            items.data.results.forEach((item: knowledgeModel) => {
                item_arr.push(item)
            });
            setKnowledges(item_arr)
        };

        if (searchParams && searchParams.get('mid')) {
            if (searchParams.get('mid') != null) {
                setMID(searchParams.get('mid'))
                updateKnowledge(searchParams.get('mid'))
            }
            if (searchParams.get('mname') != null) {
                setMName(searchParams.get('mname'))
            }
        }
    }, [searchParams.get('mid')])

    return (
        <EnableSidebar>
            <div className='d-flex flex-stack flex-wrap'>
                <div className='d-flex align-items-center py-1'>
                    <h1 className='fs-2x fw-bolder text-gray-900 mb-5 me-1'>
                        {searchParams.get('mname')}
                    </h1>
                </div>
            </div>
            {
                knowledges && knowledges.length == 0 && <span className='fs-2 text-danger'>ไม่พบรายการ</span>
            }

            {knowledges && knowledges.map((item, i) => {
                return (
                    <KnowledgeWidget
                        key={i}
                        id={item.id}
                        icon='/media/avatars/guide.png'
                        class_name='mb-2 mb-xxl-5'
                        title={item.title}
                        detail={item.description}
                        pdf_file={item.pdf_file}
                        datetime={item.updated_at} 
                        source_parent="multi_knowledge"
                        mid={mid}
                        mname={mname}/>
                )
            })}

        </EnableSidebar>
    )
}

export { MultipleKnowledge }